import { Injectable } from '@angular/core';
@Injectable()
export class StorySearch {
    storyNames?: string[];
    statuses?: number[];
    userIds?: number[];
    publishedFromDate?: Date;
    publishedToDate?: Date;
    editedFromDate?: Date;
    editedToDate?: Date;
    contactIds?: number[];
    subjectIds?: number[];
}
